// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { catchError, map } from 'rxjs/operators';

export interface ZipCode {
  state: string;
  town: string;
  zip: string;
}

export interface Town {
  state: 'string';
  town: 'string';
}

export interface Address {
  addr: string;
  state: string;
  town: string;
}

@Injectable({
  providedIn: 'root',
})
export class TigerService {
  private readonly options: { headers: HttpHeaders };

  constructor(private httpClient: HttpClient) {
    this.options = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
      }),
    };
  }

  getZipCodes(zip: string, town = ''): Observable<ZipCode[]> {
    return this.httpClient
      .get<
        ZipCode[]
      >(`${environment.tigerService}search/zip?zip=${zip}${town ? `&town=${town}` : ''}`, this.options)
      .pipe(
        map((zipCode: ZipCode[]) =>
          Array.from(new Set(zipCode.map((a) => a.zip))).map((item) =>
            zipCode.find((a) => a.zip === item),
          ),
        ),
        catchError(() => of([])),
      );
  }

  getTown(town: string): Observable<Town[]> {
    return this.httpClient
      .get<
        Town[]
      >(`${environment.tigerService}search/town?town=${town}`, this.options)
      .pipe(catchError(() => of([])));
  }

  getAddress(lat: number, lng: number): Observable<Address> {
    return this.httpClient
      .get<Address>(
        `${environment.tigerService}point-lookup/address?lat=${lat}&lng=${lng}`,
        this.options,
      )
      .pipe(catchError(() => of({ addr: `${lat}, ${lng}` } as Address)));
  }
}
